import { Component } from "@angular/core";

@Component({
    selector: 'red-dummy',
    template: ''
})
export class DummyComponent { }